import {usePathway} from "../contexts/PathwayContext";
import {useEffect} from "react";
import getBrowserHashedUserId from "../utils/getBrowserHashedUserId";

export type PathwayIdentifyProps = {
  userId: string|undefined|null;
  session: Record<string, string>,
}

const PathwayIdentify: React.FC<PathwayIdentifyProps> = ({ userId, session }) => {
  const { pathway } = usePathway();
  const sessionJson = JSON.stringify(session);

  useEffect(() => {
    ((async () => {
      pathway.userEnrich();

      let foundUserId = userId;

      if (!userId && typeof window !== 'undefined') {
        if (!!window?.segment?.segmentTracking?.userId) {
          foundUserId = window?.segment?.segmentTracking?.userId
        } else if (!!session?.username) {
          foundUserId = await getBrowserHashedUserId(session.username)
        }
      }

      // Only set the userId if we have it, otherwise let Segment use the anonymousId
      if (foundUserId) {
        session.userId = foundUserId;
      }

      pathway.identify(session)
    })());
  }, [userId, sessionJson])

  return null;
}

export default PathwayIdentify;